import { instance } from '@/api/instances'

const getObstetricData = async (store, personId) => {
  try {
    const data = await instance.get(`persons/${personId}/pregnancies`)

    store.commit('setObstetricData', data)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'pillars/clinicalProfile/getObstetricData' },
      { root: true }
    )
  }
}

const registerPregnancyData = async (store, { value, personId }) => {
  try {
    const method = value.id ? 'put' : 'post'
    const data = await instance[method](`persons/${personId}/pregnancies`, {
      json: value
    })
    store.commit('setObstetricData', data)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'pillars/clinicalProfile/registerPregnancyData' },
      { root: true }
    )
  }
}

const deletePregnancy = async (store, { id, personId }) => {
  try {
    const data = await instance.delete(`persons/${personId}/pregnancies/${id}`)

    store.commit('setObstetricData', data)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'pillars/clinicalProfile/deletePregnancy' },
      { root: true }
    )
  }
}

const clearState = store => {
  store.commit('clearState')
}

export default {
  getObstetricData,
  registerPregnancyData,
  deletePregnancy,
  clearState
}
